export default "__VITE_ASSET__D6KOygD2__"